// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3CyFF","legacyBtn":"MutateMid_legacyBtn__xeYFB"};